export const externalRoutes = {
  giftFlom: 'https://gift.flom.co',
};
